import Vue from 'vue';
import Vuex from 'vuex';

import configurations from './module/configurations';
import access from './module/access';
import preSaleLocks from './module/preSaleLocks';
import releases from './module/releases';
import clara from './module/clara';
import supportWidget from './module/supportWidget';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    configurations,
    access,
    preSaleLocks,
    releases,
    clara,
    supportWidget
  }
});
